<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{ $t('administration.employee.employeeProfile.previewCard') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card-wrapper>
        <div
          class="table-responsive drive-items-table-wrapper ts-overflow-y-auto ts-overflow-x-hidden"
          style="max-height: 65vh;"
        >
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th class="type">Teacher Card</th>
                <th class="teacherName">Teacher Name</th>
                <th class="teacherCardSide">Card Side</th>
                <th class="text-center" width="1%">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(urlImage, index) in urlImages"
                :key="index"
                class="ts-cursor-pointer"
              >
                <td class="type" valign="bottom">
                  <img
                    class="h-full w-full rounded-lg object-cover shadow-lg"
                    :icon-size="iconSize"
                    :src="urlImage.url"
                    alt=""
                    v-viewer="{ toolbar: false }"
                    loading="lazy"
                    style="max-height: 106px;"
                  />
                </td>
                <td class="teacherName" valign="bottom">
                  {{ urlImage.teacher_name }}
                </td>
                <td class="teacherName" valign="bottom">
                  {{ urlImage.side }}
                </td>
                <td class="text-center ts-space-x-2" valign="bottom">
                  <a
                    @click.prevent="download(urlImage.url)"
                    v-tooltip="'Download'"
                    class="text-primary"
                    ><i class="fa fa-download"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-card-wrapper>
    </ts-loading-banner>
  </ts-card>
</template>
<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
import * as FileDownload from 'downloadjs'
export default {
  name: 'previewCardDownload',
  props: {
    id_list: {
      type: Array
    },
    side: {
      type: String
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      iconSize: 'fa-2x',
      loading: false,
      urlImages: ''
    }
  },
  created() {
    this.previewCardDownload()
  },
  methods: {
    previewCardDownload() {
      this.loading = true
      this.$store
        .dispatch('teacherProfile/printCard', {
          teacher_id_list: this.id_list,
          side: this.side,
          type: this.type
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.loading = false
          this.urlImages = response.url_images
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = true
        })
    },
    download(data) {
      FileDownload(data)
    }
  }
}
</script>
